import * as React from "react";
import AuthContext from "src/context/AuthContext";
import Authorization from "src/common/Authorization";
import { Redirect } from "react-router-dom";

const requiresPermissions = (
	LoComponent: any,
	requiredPermissions: string[]
) => {
	return class extends React.Component {
		public constructor(props: any) {
			super(props);
		}

		public render = () => {
			return (
				<AuthContext.Consumer>
					{({ currentUser }) => {
						if (!currentUser) {
							console.error("User is not logged in");
							return null;
						}
						return Authorization.requiresPermissions(
							currentUser,
							requiredPermissions,
							this.renderComponent,
							this.redirect
						);
					}}
				</AuthContext.Consumer>
			);
		};

		public renderComponent = (currentUser: CurrentUserDTO) => {
			return <LoComponent currentUser={currentUser} {...this.props} />;
		};

		public redirect = () => {
			return <Redirect to="/401" />;
		};
	};
};

export default requiresPermissions;
